import { API_LOAN_GET_HMDA, API_LOAN_GET_HMDA_BY_KEY } from 'config'
import Api from 'services/api'

export const getHmda = () => {
  return Api.get(API_LOAN_GET_HMDA)
}

export const updateHmda = (key: string, value: any) => {
  return Api.put(API_LOAN_GET_HMDA_BY_KEY, { value }, { key })
}

export const getHmdaLogs = (key: string) => {
  return Api.get(API_LOAN_GET_HMDA_BY_KEY, { key }, { key: 'log' })
}
